import { render, staticRenderFns } from "./authoritySetting.vue?vue&type=template&id=e0edeae8&scoped=true&"
import script from "./authoritySetting.vue?vue&type=script&lang=js&"
export * from "./authoritySetting.vue?vue&type=script&lang=js&"
import style0 from "./authoritySetting.vue?vue&type=style&index=0&id=e0edeae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0edeae8",
  null
  
)

export default component.exports